export default __webpack_public_path__ + "static/media/lefteye.5036603d.svg";